/**
 * Height of the in-person phone shell's top bar. Shared so layers outside the
 * shell - system notifications open below the bar - do not depend on the
 * shell's own components.
 */
export const PHONE_TOP_BAR_HEIGHT = 64
